<span
  class="info-icon-tooltip info-icon material-icons-outlined"
  aria-label="Show/Hide Info"
  [matTooltip]="message"
  matTooltipPosition="right"
></span>
